import { useEffect } from 'react';
import { useNavigate } from 'mini-react-router-dom';

/**
 * Hook to handle route change event
 * NOTE: This hook will be removed once shareViaLite implementation is refactored
 */
export const useHandleRouteChangeEvent = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const handleRouteChangeSignal = (e: CustomEvent) => {
            e.detail.path && navigate(e.detail.path);
        };

        window.addEventListener('routeChange', handleRouteChangeSignal);

        return () => {
            window.removeEventListener('routeChange', handleRouteChangeSignal);
        };
    }, [navigate]);
};
